import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { InputPercent } from '@nerdwallet/currency';
import num from '@nerdwallet/nw-client-lib/num';

import { REFINANCE } from '../../../lib/analytics-constants';
import { validationsSelector } from '../../../lib/selectors';
import { inputsSelector } from '../../../lib/selectors/refinance-calculator-selectors';
import { RefinanceInput, inputOnChange } from '../../../lib/utils';

type OnChangeEvent = React.ChangeEvent<HTMLInputElement>;

const RefinanceInterestRateInput: React.FC<RefinanceInput> = ({
  inputs,
  dispatch,
  analytics,
  validations,
  label = '',
  tooltip = '',
  fullWidth,
  className = '',
}) => {
  const decimalValue = inputs?.refinanceInterestRate;
  const percentageValue = !_.isNil(decimalValue)
    ? num.formatPercent(decimalValue)
    : '';
  const errorMessage = validations?.refinanceInterestRate?.[0];
  const error = Boolean(errorMessage);
  const analyticsEnabled = analytics && analytics?.enabled;
  const bedrockAnalytics =
    analyticsEnabled && analytics?.payload?.bedrock?.eventType;

  const onInputChange = (e: OnChangeEvent) => {
    let bedrock;
    if (bedrockAnalytics) {
      const bedrockProps = analytics?.payload?.bedrock;
      bedrock = {
        ...bedrockProps,
        valueFieldName: 'value_n',
      };
    }

    inputOnChange({
      event: e,
      dispatch,
      bedrock,
      fieldName: 'refinanceInterestRate',
      calculator: REFINANCE,
      inputType: 'percentage',
    });
  };

  return (
    <InputPercent
      onChange={onInputChange}
      value={percentageValue}
      decimalScale={3}
      numberOfDigits={3}
      error={error}
      errorMessage={errorMessage}
      label={label}
      tooltip={tooltip}
      className={className}
      fullWidth={fullWidth}
    />
  );
};

const mapStateToProps = (state) => ({
  inputs: inputsSelector(state),
  validations: validationsSelector(state),
});

export default connect(mapStateToProps)(RefinanceInterestRateInput);
